import { useState, useEffect } from 'react';
import { resolveColorWithOverrides } from '../../charts/shared/palettes';
import ColorPickerPopover from './ColorPickerPopover';

function ColorMapSection({ items, overrides, onChange, onReset, ui, paletteColors }) {
  const [expanded, setExpanded] = useState(false);
  const [openPicker, setOpenPicker] = useState(null);
  const [pickerAnchor, setPickerAnchor] = useState(null);
  const overrideCount = items.filter(item => overrides?.[item.key]).length;

  useEffect(() => {
    if (overrideCount > 0) setExpanded(true);
  }, [overrideCount]);

  return (
    <div className="border-t pt-3 mt-3" style={{ borderTopColor: ui.borderSecondary }}>
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center justify-between w-full text-xs mb-2"
        style={{ color: ui.textSecondary }}
      >
        <span className="font-medium" style={{ color: ui.text }}>
          Customize Colors
          {!expanded && items.length > 0 && (
            <span className="ml-1 font-normal" style={{ color: ui.textSecondary }}>
              ({items.length})
            </span>
          )}
        </span>
        <span>{expanded ? '\u25BE' : '\u25B8'}</span>
      </button>

      {expanded && (
        <div>
          <div className="space-y-1.5 max-h-64 overflow-y-auto">
            {items.map((item) => {
              const resolved = resolveColorWithOverrides(item.autoColor, item.key, overrides);
              const hasOverride = !!overrides?.[item.key];
              return (
                <div key={item.key} className="flex items-center gap-2 text-xs">
                  <button
                    onClick={(e) => {
                      if (openPicker === item.key) {
                        setOpenPicker(null);
                        setPickerAnchor(null);
                      } else {
                        setOpenPicker(item.key);
                        setPickerAnchor(e.currentTarget);
                      }
                    }}
                    className="w-5 h-5 border flex-shrink-0"
                    style={{
                      backgroundColor: resolved,
                      borderColor: openPicker === item.key ? ui.text : ui.borderSecondary,
                    }}
                    title={`${resolved} \u2014 click to change`}
                  />
                  {openPicker === item.key && pickerAnchor && (
                    <ColorPickerPopover
                      anchorEl={pickerAnchor}
                      currentColor={resolved}
                      onSelect={(color) => {
                        onChange(item.key, color);
                        setOpenPicker(null);
                        setPickerAnchor(null);
                      }}
                      onClose={() => {
                        setOpenPicker(null);
                        setPickerAnchor(null);
                      }}
                      ui={ui}
                      paletteColors={paletteColors}
                      assignedColors={items.map(it =>
                        resolveColorWithOverrides(it.autoColor, it.key, overrides)
                      )}
                    />
                  )}
                  <span
                    className="flex-1 truncate"
                    style={{ color: ui.text }}
                    title={item.label}
                  >
                    {item.label}
                  </span>
                  {hasOverride && (
                    <button
                      onClick={() => onChange(item.key, null)}
                      className="text-xs flex-shrink-0 opacity-50 hover:opacity-100"
                      style={{ color: ui.textSecondary }}
                      title="Reset to auto color"
                    >
                      &#8634;
                    </button>
                  )}
                </div>
              );
            })}
          </div>
          {overrideCount > 0 && (
            <button
              onClick={onReset}
              className="w-full text-xs border px-2 py-1 mt-2 ui-hover"
              style={{ borderColor: ui.borderSecondary, color: ui.textSecondary }}
            >
              Reset All Colors
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default ColorMapSection;
